import React from "react";
import "./Careers.css";
import { motion } from "framer-motion";

const Careers = () => {
  return (

<section className="careers">
  <div className="careers-overlay">
    <div className="careers-content">
      {/* Careers Tag (from top) */}
      <motion.span
        className="careers-tag"
        initial={{ opacity: 0, y: -40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        viewport={{ amount: 0.3 }}
      >
        Careers
      </motion.span>

      {/* Heading (from bottom) */}
      <motion.h2
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut", delay: 0.1 }}
        viewport={{ amount: 0.3 }}
      >
        Shaping the Future <br /> of Industry
      </motion.h2>

      {/* Paragraph (fade + slide up) */}
      <motion.p
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
        viewport={{ amount: 0.3 }}
      >
        Our vision is straightforward yet forceful: to empower industries with
        the industrial products and materials they require to create stronger,
        safer, and more efficient futures.
      </motion.p>

      {/* Button (scale + fade in) */}
      <motion.button
        className="cta-btn"
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: "easeOut", delay: 0.3 }}
        viewport={{ amount: 0.3 }}
      >
        Join Us
      </motion.button>
    </div>
  </div>
</section>

  );
};

export default Careers;
